import React, { useState, useEffect } from "react";
import "./Withdraw.css";
// import "../../../src/App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaFileUpload } from "react-icons/fa";
import Header from "../header/Header";
import ExposureHeader from "../ExposureHeader/ExposureHeader";
import Appconfig from "../../config/config";
import Helper from "../../helper";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Modal, Input, Table, Image, Button, Switch, Tooltip } from "antd";
import { getPaymentMethods } from "../../redux/slice/paymentMethod/paymentMethodSlice";
import { useSelector, useDispatch } from "react-redux";
import {
  DeleteOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

const AddWithdrawMethod = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userInfo = Helper();
  const userInfos = useSelector((state) => state.paymentMethods); // Use selector to access state
  const paymentMethod = userInfos?.paymentMethods || [];
  console.log("paymentMethod", paymentMethod);

  const [balance, setBalance] = useState(0);
  const [exposure, setExposure] = useState(0);
  let balanceWithExp = balance - Math.abs(exposure);

  const [inputValue, setInputValue] = useState("");
  const [selectedOption, setSelectedOption] = useState("new-account"); // Set default to 'new-account'
  const [isSubmitted, setIsSubmitted] = useState(false); // State for form submission
  const [buttonText, setButtonText] = useState("Submit"); // State for button text
  const [showPaymentMethods, setShowPaymentMethods] = useState(false);
  const [showAddAccountForm, setAddAccountForm] = useState(false);
  const [showBankForm, setShowBankForm] = useState("");
  const [showUpiForm, setShowUpiForm] = useState("");
  const [showEditPopup, setShowEditPopup] = useState(false); // State to handle Edit form popup visibility
  const [editingSection, setEditingSection] = useState(null); // Track which section is being edited
  const [showPreviousAccount, setShowPreviousAccount] = useState(false);
  const [amountValue, setAmountValue] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountHolder, setAccountHolder] = useState("");
  const [bankName, setBankName] = useState("");
  const [showWithdrawHistory, setShowWithdrawHistory] = useState(true);

  const [upiId, setUpiId] = useState("");
  const [upiHolder, setUpiHolder] = useState("");
  const [button, setButton] = useState(false);

  const [AcNumValidationError, setAcNumValidationError] = useState(
    "Please enter account number"
  );
  const [AcHolderValidationError, setAcHolderValidationError] = useState(
    "Please enter account holder name"
  );
  const [IfscValidationError, setIfscValidationError] = useState(
    "Please enter ifsc code"
  );
  const [BankValidationError, setBankValidationError] = useState(
    "Please enter bank name"
  );
  const [UPIValidationError, setUPIValidationError] =
    useState("Please enter id");
  const [HolderValidationError, setHolderValidationError] = useState(
    "Please enter holder name"
  );

  const [withdrawHistory, setWithdrawHistory] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);

  const [isTermsChecked, setIsTermsChecked] = useState(false);

  const [bankDetails, setBankDetails] = useState({
    name: "Example",
    accountNumber: "12345678xxxx",
    ifscCode: "SBIN000002",
    bankName: "State Bank of India",
  });

  const [UPIDetails, setUPIDetails] = useState({
    upi_id: "1234fgd",
    phoneNumber: "12345678xxxx",
  });

  // Handle changes in the Bank input fields during editing
  const handleBankInputChange = (e) => {
    const { name, value } = e.target;
    setBankDetails({
      ...bankDetails,
      [name]: value,
    });
  };

  useEffect(() => {
    getUserPaymentMethods();
  }, []);

  const getUserPaymentMethods = () => {
    dispatch(
      getPaymentMethods({
        site_code: Appconfig.sitecodes,
        user_id: userInfo?._id,
      })
    );
  };

  useEffect(() => {
    if (userInfo) {
      getBalance();
    }
  }, [userInfo]);

  function getBalance() {
    var data = JSON.stringify({
      user_id: userInfo?._id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}ledger/getUserBalance`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result == 0) {
        } else {
          setBalance(response.data.resultData?.balance);
          setExposure(response.data.resultData?.exposure);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // Handle changes in the UPI input fields during editing
  const handleUPIInputChange = (e) => {
    const { name, value } = e.target;
    setUPIDetails({
      ...UPIDetails,
      [name]: value,
    });
  };

  const toggleEditPopup = (section) => {
    setEditingSection(section); // Set the section (either "bank" or "upi")
    setShowEditPopup(!showEditPopup); // Toggle the popup
  };

  function deletePaymentDetails(id) {
    var data = JSON.stringify({
      id: id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}paymentMethod/deleteType`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success(response.data.resultMessage, { autoClose: 2000 });
          getUserPaymentMethods();
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const handlePreviousAccount = () => {
    setShowPreviousAccount(!showPreviousAccount);
    setShowPaymentMethods(false);
  };

  // Function to handle button click
  const handleButtonClick = (value) => {
    setInputValue(value);
  };

  // Function to handle payment option click
  const handleClick = (option) => {
    setSelectedOption(selectedOption === option ? null : option); // Toggle between opening/closing
  };

  const handlePaymentMethod = () => {
    setShowPaymentMethods(!showPaymentMethods);
    setShowPreviousAccount(false);

    // Hide all forms using an array of form setters
    [setShowUpiForm].forEach((setter) => setter(false));
  };

  const handleFormToggle = (form) => {
    setUpiId("");
    setUpiHolder("");
    setShowUpiForm(form);
  };

  // Button values
  const buttonValues = [500, 1000, 1500, 2000, 2500, 3000];

  const tickMark = (
    <svg
      width="58"
      height="45"
      viewBox="0 0 58 45"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#fff"
        fillRule="nonzero"
        d="M19.11 44.64L.27 25.81l5.66-5.66 13.18 13.18L52.07.38l5.65 5.65"
      />
    </svg>
  );

  function checkValidation() {
    if (showUpiForm == "Bank") {
      if (!accountNumber) {
        setAcNumValidationError("Please enter account number");
        document.querySelector(".acnum").classList.remove("hidden");
      }
      if (!accountHolder) {
        setAcHolderValidationError("Please enter holder name");
        document.querySelector(".acholder").classList.remove("hidden");
      }
      if (!ifscCode) {
        setIfscValidationError("Please enter ifsc code");
        document.querySelector(".ifsccode").classList.remove("hidden");
      }

      if (!bankName) {
        setBankValidationError("Please enter bank name");
        document.querySelector(".bankname").classList.remove("hidden");
      }

      if (accountNumber && accountHolder && ifscCode && bankName) {
        return true;
      }
      return false;
    } else {
      if (!upiId) {
        setUPIValidationError("Please enter upi id");
        document.querySelector(".upiid").classList.remove("hidden");
      }
      if (!upiHolder) {
        setHolderValidationError("Please enter holder name");
        document.querySelector(".holder").classList.remove("hidden");
      }
      if (upiId && upiHolder) {
        return true;
      }
      return false;
    }
  }

  // Handle submit click and toggle button text & style
  const handleSubmitClick = async (e) => {
    e.preventDefault();

    console.log();

    if (userInfo && showUpiForm) {
      if (checkValidation()) {
        const formData = new FormData();

        formData.append("master_id", userInfo?.master_id);
        formData.append("user_id", userInfo?._id);
        formData.append("site_code", userInfo?.site_code);
        formData.append("type", showUpiForm);
        formData.append("bank_name", bankName);
        formData.append("account_no", accountNumber);
        formData.append("account_holder_name", accountHolder);
        formData.append("ifsc_code", ifscCode);
        formData.append("holder_name", upiHolder);
        formData.append("upi_id", upiId);

        var config = {
          method: "post",
          url: `${Appconfig.apiUrl}withdraw/addWithdrawPaymentMethod`,
          headers: {
            "Content-Type": "application/json",
          },
          data: formData,
        };
        axios(config)
          .then(function (response) {
            if (response.data.result) {
              setButtonText("Thanks");
              setIsSubmitted(true);
              toast.success(response.data.resultMessage, { autoClose: 2000 });

              setTimeout(() => {
                navigate("/withdraw");
              }, 2000);
            } else {
              toast.error(response.data.resultMessage, { autoClose: 2000 });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    } else {
      toast.error("Please select payment method or fill all the fields!", {
        autoClose: 2000,
      });
    }
  };

  function cancelWithdrawRequest(record, status) {
    setButton(true);
    var data = JSON.stringify({
      record: record,
      status: status,
      master_details: userInfo,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}withdraw/confirmWithdraw`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success(response.data.resultMessage, { autoClose: 2000 });
          getWithdrawHistory();
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
        setButton(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // const methodColumns = [
  //   {
  //     title: "Type",
  //     sorter: true,
  //     render: (_, record) => <span className="">{record?.type}</span>,
  //   },
  //   {
  //     title: "Holder Name",
  //     sorter: true,
  //     render: (_, record) => (
  //       <span className="">
  //         {record?.type == "Bank" ? record?.accountHolder : record?.holderName}
  //       </span>
  //     ),
  //   },
  //   {
  //     title: "UPI ID",
  //     sorter: true,
  //     render: (_, record) => <span className="">{record?.upiId}</span>,
  //   },
  //   {
  //     title: "Account No.",
  //     sorter: true,
  //     render: (_, record) => <span className="">{record?.accountNo}</span>,
  //   },
  //   {
  //     title: "UPI ID",
  //     sorter: true,
  //     render: (_, record) => <span className="">{record?.upiId}</span>,
  //   },
  //   {
  //     title: "IFSC Code",
  //     sorter: true,
  //     render: (_, record) => <span className="">{record?.ifscCode}</span>,
  //   },
  //   {
  //     title: "Bank Name",
  //     sorter: true,
  //     render: (_, record) => <span className="">{record?.bankName}</span>,
  //   },
  //   {
  //     title: "More",
  //     sorter: true,
  //     render: (_, record) => (
  //       <div className="">
  //         <button
  //           disabled={button}
  //           onClick={() => deleteWithdrawMethod(record?._id)}
  //           className="custom-button"
  //         >
  //           <span>Delete</span>
  //         </button>
  //         <button
  //           disabled={button}
  //           onClick={() =>
  //             statusWithdrawMethod(
  //               record?._id,
  //               record?.status == "Active" ? "Inactive" : "Active"
  //             )
  //           }
  //           className="custom-button"
  //           style={{ color: record?.status == "Active" ? "green" : "red" }}
  //         >
  //           <span>{record?.status}</span>
  //         </button>
  //       </div>
  //     ),
  //   },
  // ];


  const methodColumns = [
    {
      title: <span className="text-white">Type</span>,
      dataIndex: "type",
      key: "type",
      align: "center",
    },
    {
      title: <span className="text-white">Holder Name</span>,
      key: "holderName",
      align: "center",
      render: (_, record) =>
        record?.type === "Bank" ? record?.accountHolder : record?.holderName,
    },
    {
      title: <span className="text-white">UPI ID</span>,
      dataIndex: "upiId",
      key: "upiId",
      align: "center",
    },
    {
      title: <span className="text-white">Account No.</span>,
      dataIndex: "accountNo",
      key: "accountNo",
      align: "center",
    },
    {
      title: <span className="text-white">IFSC Code</span>,
      dataIndex: "ifscCode",
      key: "ifscCode",
      align: "center",
    },
    {
      title: <span className="text-white">Bank Name</span>,
      dataIndex: "bankName",
      key: "bankName",
      align: "center",
    },
    {
      title: <span className="text-white">More</span>,
      key: "actions",
      align: "center",
      render: (_, record) => (
        <div className="flex gap-2 justify-center">
          {/* Delete Button */}
          <Tooltip title="Delete Method">
            <button
              disabled={button}
              onClick={() => deleteWithdrawMethod(record?._id)}
              className="px-2 py-1 flex items-center gap-1 rounded-md bg-red-500 text-white hover:bg-red-600 transition"
            >
              <DeleteOutlined />
              Delete
            </button>
          </Tooltip>

          {/* Status Toggle Button */}
          <Tooltip title="Change Status">
            <button
              disabled={button}
              onClick={() =>
                statusWithdrawMethod(
                  record?._id,
                  record?.status === "Active" ? "Inactive" : "Active"
                )
              }
              className={`px-2 py-1 flex items-center gap-1 rounded-md text-white transition ${
                record?.status === "Active"
                  ? "bg-green-500 hover:bg-green-600"
                  : "bg-gray-500 hover:bg-gray-600"
              }`}
            >
              {record?.status === "Active" ? (
                <CheckCircleOutlined />
              ) : (
                <CloseCircleOutlined />
              )}
              {record?.status}
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];

  const getWithdrawHistory = () => {
    let site_code = Appconfig.sitecodes;
    let data = JSON.stringify({
      site_code: site_code,
      user_id: userInfo?._id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}withdraw/getWithdrawHistory`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          setWithdrawHistory(response.data.resultData);
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const deleteWithdrawMethod = (id) => {
    let site_code = Appconfig.sitecodes;
    let data = JSON.stringify({
      site_code: site_code,
      id: id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}withdraw/deleteWithdrawMethod`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          dispatch(
            getPaymentMethods({
              site_code: Appconfig.sitecodes,
              user_id: userInfo?._id,
            })
          );
          toast.success(response.data.resultMessage, { autoClose: 2000 });
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const statusWithdrawMethod = (id, status) => {
    let site_code = Appconfig.sitecodes;
    let data = JSON.stringify({
      site_code: site_code,
      id: id,
      status: status,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}withdraw/statusWithdrawMethod`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result) {
          dispatch(
            getPaymentMethods({
              site_code: Appconfig.sitecodes,
              user_id: userInfo?._id,
            })
          );
          toast.success(response.data.resultMessage, { autoClose: 2000 });
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  function selectPaymentDetail(detail) {
    setBankName(detail?.bankName);
    setAccountNumber(detail?.accountNo);
    setAccountHolder(detail?.accountHolder);
    setIfscCode(detail?.ifscCode);
    setUpiId(detail?.upiId);
    setUpiHolder(detail?.holderName);
    setShowUpiForm(detail?.type);
  }

  useEffect(() => {
    getWithdrawHistory();
    handlePaymentMethod();
  }, []);

  // useEffect(() => {
  //   document.body.style.overflow = selectedOption === "new-account" ? "hidden" : "auto";
  // }, [selectedOption]);

  const handlePaymentMethodSelect = (method) => {
    setShowUpiForm(method); // e.g. "UPI", "Bank", etc.
    setSelectedOption("new-account"); // or whatever logic you use
    setShowFormModal(true); // <-- open modal
  };

  useEffect(() => {
    document.body.style.overflow = showFormModal ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showFormModal]);

  return (
    <>
      {/* <Header /> */}
      {/* <ExposureHeader /> */}
      {/* <div>
        <nav className="breadcrumb-nav" aria-label="Breadcrumb">
          <a title="LotusPlus365-Home" className="home-link" href="/">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 576 512"
              fill="var(--icon-color-brand-secondary1)"
            >
              <path d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"></path>
            </svg>{" "}
          </a>
          <div className="breadcrumb-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="23"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="var(--icon-color-tertiary2)"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M9 6l6 6l-6 6"></path>
            </svg>
            <a
              className="breadcrumb-back-link"
              aria-current="page"
              title="LotusPlus365-Withdraw"
              href="/withdraw"
            >
              Back
            </a>
          </div>
        </nav>
      </div> */}

      <div className="lg:flex sticky top-0 app-bg font-lato-bold w-full justify-between items-center lg:pt-0">
        <div>
          <nav
            className="flex items-center justify-center w-max space-x-1 text-sm text-white/80 p-2"
            aria-label="Breadcrumb"
          >
            <a title="LotusPlus365-Home" className="flex items-center" href="/">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 576 512"
                fill="var(--icon-color-brand-secondary1)"
              >
                <path
                  d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
                ></path>
              </svg>
            </a>
            <div className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="23"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="var(--icon-color-tertiary2)"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M9 6l6 6l-6 6"></path>
              </svg>
              <a
                className="ml-1 text-lg transition-all ease-in-out duration-300 text-text_brand_primary font-semibold hover:underline"
                aria-current="page"
                title="LotusPlus365-Withdraw"
                href="/withdraw"
              >
                Back
              </a>
            </div>
          </nav>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-xl p-6">
        <div className="w-full sticky bottom-0 left-0 pb-2 app-bg pt-2">
            <div
                className="relative overflow-hidden bg-bg_text_brand_primary w-full text-text_color_primary2 h-10 text-base shadow-lg  rounded-md font-[900] leading-4 disabled:opacity-70 flex gap-x-1 items-center justify-center "
                ><span>Add New Payment Method</span>
            </div>
        </div>

        {/* <div className="payment-method-section">
          <h3 className="section-title">Select Payment Method</h3>
          <div className="payment-method-grid">
            {Appconfig.withdraw_account_type?.map((type) => (
              <button
                key={type}
                onClick={() => handlePaymentMethodSelect(type)}
                className={`payment-button ${
                  type === showUpiForm ? "selected" : ""
                }`}
              >
                <img
                  src={`../Images/${
                    type === "Bank"
                      ? "bank.png"
                      : type === "Gpay"
                      ? "icons8-google-pay.svg"
                      : type === "UPI"
                      ? "icons8-bhim-50.svg"
                      : type === "Phonepe"
                      ? "icons8-phone-pe.svg"
                      : "icons8-paytm.svg"
                  }`}
                  alt={type}
                  className="payment-icon"
                />
                <span className="payment-label">{type}</span>
              </button>
            ))}
          </div>
        </div> */}
        <div className="mb-8">
          <h3 className="text-lg font-semibold mb-2">Select Payment Method</h3>
          <div className="grid grid-cols-1 gap-4">
            <button
              key="Bank"
              onClick={() => handlePaymentMethodSelect("Bank")}
              className={`flex flex-col items-center justify-center py-2 border rounded-xl transition hover:shadow-lg ${
                showUpiForm === "Bank" ? "ring-2 ring-[#0c9971]" : ""
              }`}
            >
              <img
                src="../Images/bank.png"
                alt="Bank"
                className="w-12 h-12 mb-2"
              />
              <span className="text-sm font-medium">Bank</span>
            </button>
          </div>
        </div>

        {showUpiForm === "Bank" && showFormModal && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
            onClick={() => setShowFormModal(false)} // Close on outside click
          >
            <div
              className="bg-white w-full max-w-md rounded-lg shadow-lg p-6 relative overflow-y-auto max-h-[90vh]"
              onClick={(e) => e.stopPropagation()} // Prevent close on inner click
            >
              {/* Close Button */}
              <button
                onClick={() => setShowFormModal(false)}
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-xl"
              >
                &times;
              </button>

              {/* FORM */}
              <form onSubmit={handleSubmitClick} className="space-y-4">
                {/* Bank Form */}
                <input
                  type="text"
                  value={ifscCode}
                  onChange={(e) => setIfscCode(e.target.value)}
                  placeholder="Enter IFSC Code"
                  className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0c9971]"
                />
                <span className="text-red-500 text-sm">{IfscValidationError}</span>

                <input
                  type="number"
                  value={accountNumber}
                  onChange={(e) => setAccountNumber(e.target.value)}
                  placeholder="Enter Account Number"
                  className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0c9971]"
                />
                <span className="text-red-500 text-sm">{AcNumValidationError}</span>

                <input
                  type="text"
                  value={bankName}
                  onChange={(e) => setBankName(e.target.value)}
                  placeholder="Enter Bank Name"
                  className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0c9971]"
                />
                <span className="text-red-500 text-sm">{BankValidationError}</span>

                <input
                  type="text"
                  value={accountHolder}
                  onChange={(e) => setAccountHolder(e.target.value)}
                  placeholder="Enter Account Name"
                  className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0c9971]"
                />
                <span className="text-red-500 text-sm">{AcHolderValidationError}</span>

                {/* UPI Number input for Bank option */}
                {/* <input
                  type="text"
                  value={upiId}
                  onChange={(e) => setUpiId(e.target.value)}
                  placeholder="Enter UPI Number"
                  className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#0c9971]"
                />
                <span className="text-red-500 text-sm">{UPIValidationError}</span> */}

                {/* Terms Checkbox */}
                <label className="flex items-center space-x-2 text-sm">
                  <input
                    type="checkbox"
                    className="accent-[#0c9971]"
                    checked={isTermsChecked}
                    onChange={(e) => setIsTermsChecked(e.target.checked)}
                  />
                  <span>
                    I have read the{" "}
                    <a href="#" className="underline text-[#0c9971]">
                      terms of payment and withdrawal policy
                    </a>
                  </span>
                </label>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={isSubmitted}
                  className={`w-full py-3 rounded-lg font-semibold text-white transition ${
                    isSubmitted
                      ? "bg-green-500 cursor-not-allowed"
                      : "bg-[#0c9971] hover:bg-[#0a8060]"
                  }`}
                >
                  {buttonText}
                </button>
              </form>
            </div>
          </div>
        )}

      </div>

      <div className="mt-3 w-full flex flex-row items-center justify-center gap-3 flex-wrap">
        <button
          onClick={() => setShowWithdrawHistory(!showWithdrawHistory)}
          className="px-4 py-2 bg-[#0c9971] text-white rounded font-semibold mb-2"
        >
          {showWithdrawHistory ? "Hide Withdraw Methods" : "Show Withdraw Methods"}
        </button>

      </div>
        {/* {showWithdrawHistory && (
          <div className="history-section">
            <h3>Previous Methods</h3>
            <div className="history-table-container">
              <Table
                columns={methodColumns}
                className="min-w-full border border-gray-200 rounded-lg"
                dataSource={paymentMethod}
                bordered
                pagination
              />
            </div>
          </div>
        )} */}
        {/* {showWithdrawHistory && (
          <div className="mt-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-900">Previous Methods</h3>
            <div className="overflow-x-auto">
              <Table
                columns={methodColumns}
                className="min-w-full border border-gray-200 rounded-lg"
                dataSource={paymentMethod}
                bordered
                pagination
              />
            </div>
          </div>
        )} */}


        {showWithdrawHistory && (
          <div className="mt-6">
            <div className="bg-white shadow-lg rounded-2xl p-1">
              <h3 className="text-xl font-bold mb-2 text-gray-900">
                Previous Methods
              </h3>
              <div className="overflow-x-auto">
                <Table
                  columns={methodColumns}
                  dataSource={paymentMethod}
                  bordered
                  pagination={{ pageSize: 10 }}
                  className="rounded-lg overflow-hidden custom-green-header"
                  scroll={{ x: "max-content" }}
                />
              </div>
            </div>
          </div>
        )}
        {/* <div className="mt-6">
          <div className="bg-white shadow-lg rounded-2xl p-1">
            <h3 className="text-2xl font-bold mb-2 text-gray-900">
              Withdraw History
            </h3>
            <div className="overflow-x-auto">
              <Table
                columns={historyColumns}
                dataSource={withdrawHistory}
                pagination={{ pageSize: 10 }}
                bordered
                rowClassName="hover:bg-gray-50"
                className="rounded-lg overflow-hidden custom-green-header"
                scroll={{ x: "max-content" }}
              />
            </div>
          </div>
        </div> */}
    </>
  );
};

export default AddWithdrawMethod;
